var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownMedium = function SvgChevronDownMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A8447",
    d: "M2.822 7.793a1 1 0 0 1 1.414 0l7.779 7.778 7.778-7.778a1 1 0 1 1 1.414 1.414l-8.485 8.485a1 1 0 0 1-1.415 0L2.823 9.207a1 1 0 0 1 0-1.414"
  })));
};
export default SvgChevronDownMedium;